
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/complains-formular",
      function () {
        return require("private-next-pages/complains-formular.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/complains-formular"])
      });
    }
  